// import React, { useEffect, useState, useContext } from "react";
// import axios from "axios";
// import {
//   AppBar,
//   Toolbar,
//   IconButton,
//   Typography,
//   Box,
//   Card,
//   CardContent,
//   Avatar,
//   CircularProgress,
//   Snackbar,
//   Alert,
// } from "@mui/material";
// import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
// import DeleteIcon from "@mui/icons-material/Delete";
// import { useNavigate } from "react-router-dom";
// import { AuthContext } from "../../AuthContext/AuthContext";
// import CustomBottomNavbar from "../../Users/Post Module/FormsBottomNavbar";
// import { BASE_URL } from "../../Api/ApiUrls";
// import DeleteFailureAlert from '../../../Components/Users/Alertpage/DeleteAlert/DeleteFailureAlert';
// import DeleteSuccessAlert from '../../../Components/Users/Alertpage/DeleteAlert/DeleteSuccessAlert';
// import DeleteConfirmAlert from '../../../Components/Users/Alertpage/DeleteAlert/DeleteConfirmAlert';


// const BuiltSuitProperties = () => {
//   const navigate = useNavigate();
//   const { userId } = useContext(AuthContext);

//   const [data, setData] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");
//   const [deletingId, setDeletingId] = useState(null);
// const [showDeleteSuccess, setShowDeleteSuccess] = useState(false);
// const [showDeleteFailure, setShowDeleteFailure] = useState(false);
// const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
// const [requestToDelete, setRequestToDelete] = useState(null);
// const [alertMessage, setAlertMessage] = useState("");
//   const [propertyToDelete, setPropertyToDelete] = useState(null);
//   const colors = {
//     primary: "#1a1a1a",
//     secondary: "#8B7355",
//     accent: "#A52A2A",
//     background: "#b9a990",
//     cardBackground: "#FFFFFF",
//     textDark: "#1a1a1a",
//     textLight: "#FFFFFF",
//     textMuted: "#666666"
//   };

//   // Format date function
//   const formatDate = (dateString) => {
//     if (!dateString) return "Not specified";
//     const date = new Date(dateString);
//     const now = new Date();
//     const diffMs = now - date;
//     const diffMins = Math.floor(diffMs / (1000 * 60));
//     const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
//     const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

//     if (diffMins < 60) return `${diffMins}m ago`;
//     if (diffHours < 24) return `${diffHours}h ago`;
//     if (diffDays < 7) return `${diffDays}d ago`;
//     return date.toLocaleDateString("en-US", { month: "short", day: "numeric" });
//   };

// // Format budget function for min and max
// const formatBudget = (min, max) => {
//   if (!min && !max) return "Not specified";
  
//   const formatNumber = (num) => {
//     const numValue = parseFloat(num) || 0;
    
//     if (numValue >= 10000000) {       // 1 Crore+
//       return `₹${(numValue / 10000000).toFixed(1)} Cr`;
//     } else if (numValue >= 100000) {  // 1 Lakh+
//       return `₹${(numValue / 100000).toFixed(1)} L`;
//     } else if (numValue >= 1000) {    // 1 Thousand+
//       return `₹${(numValue / 1000).toFixed(1)} K`;
//     } else {
//       return `₹${numValue}`;
//     }
//   };
  
//   const minNum = parseFloat(min) || 0;
//   const maxNum = parseFloat(max) || 0;
  
//   if (minNum === maxNum) return formatNumber(minNum);
  
//   const minFormatted = formatNumber(minNum);
//   const maxFormatted = formatNumber(maxNum);
  
//   return `${minFormatted} - ${maxFormatted}`;
// };
//  const handleDeleteProperty = (e, property) => {
//   e.stopPropagation();
//   setPropertyToDelete(property);
//   setShowDeleteConfirm(true);
// };
// const performDelete = async () => {
//   if (!propertyToDelete) return;
  
//   setDeletingId(propertyToDelete.property_id);
  
//   try {
//     await axios.delete(`${BASE_URL}/property/${propertyToDelete.property_id}/`);
    
//     // Remove the deleted property from state
//     setData(prevData => prevData.filter(item => item.property_id !== propertyToDelete.property_id));
    
//     setAlertMessage("JV/JD & Build to Suit property deleted successfully!");
//     setShowDeleteSuccess(true);
    
//   } catch (err) {
//     console.error("Error deleting property:", err);
//     setAlertMessage("Failed to delete property. Please try again.");
//     setShowDeleteFailure(true);
//   } finally {
//     setDeletingId(null);
//     setPropertyToDelete(null);
//   }
// };

//   // Handle card click to navigate to detail page
//   const handleCardClick = (propertyId) => {
//     navigate(`/jv-jv-property-detail/${propertyId}`);
//   };

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         // Fetch both jv/jd and build to suit in parallel
//         const [jvjdRes, buildToSuitRes] = await Promise.all([
//           axios.post(`${BASE_URL}/properties/filter/`, {
//             include: { user_id: Number(userId), type: "jv/jd" },
//             exclude: {}
//           }),
//           axios.post(`${BASE_URL}/properties/filter/`, {
//             include: { user_id: Number(userId), type: "build to suit" },
//             exclude: {}
//           })
//         ]);

//         const jvjdData = jvjdRes.data?.data || [];
//         const buildToSuitData = buildToSuitRes.data?.data || [];

//         // Merge both arrays and sort newest first
//         const combined = [...jvjdData, ...buildToSuitData].sort(
//           (a, b) => new Date(b.created_at) - new Date(a.created_at)
//         );

//         setData(combined);
//         setLoading(false);
//       } catch (err) {
//         setError("Failed to load JV/JD & Build to Suit properties");
//         setLoading(false);
//       }
//     };

//     if (userId) {
//       fetchData();
//     } else {
//       setLoading(false);
//       setError("User not authenticated");
//     }
//   }, [userId]);
  
//   // Render property detail function
//   const renderPropertyDetail = (label, value, color = colors.textDark) => (
//     <Box sx={{ display: 'flex', alignItems: 'flex-start', mb: 0.5 }}>
//       <Typography variant="body2" color={color} sx={{ 
//         fontSize: '0.75rem', 
//         lineHeight: 1.2, 
//         minWidth: 120, 
//         flexShrink: 0,
//         fontWeight: 'bold'
//       }}>
//         {label}:
//       </Typography>
//       <Typography variant="body2" color={colors.textDark} sx={{ 
//         fontSize: '0.75rem', 
//         lineHeight: 1.2 
//       }}>
//         {value || "Not specified"}
//       </Typography>
//     </Box>
//   );

//   if (loading) {
//     return (
//       <Box
//         sx={{
//           backgroundColor: 'rgb(239, 231, 221)',
//           minHeight: '100vh',
//           display: 'flex',
//           flexDirection: 'column',
//           justifyContent: 'center',
//           alignItems: 'center',
//           gap: 3,
//         }}
//       >
//         <CircularProgress size={40} thickness={5} sx={{ color: '#000000' }} />
//         <Typography variant="h7" sx={{ color: '#000000', fontWeight: 600 }}>
//           Loading JV/JD & Build to Suit properties...
//         </Typography>
//       </Box>
//     );
//   }

//   if (error) return (
//     <Box sx={{ 
//       display: "flex", 
//       flexDirection: "column", 
//       minHeight: "100vh", 
//       backgroundColor: colors.background, 
//       justifyContent: "center", 
//       alignItems: "center" 
//     }}>
//       <Typography variant="h6" color="error">
//         {error}
//       </Typography>
//     </Box>
//   );

//   return (
//     <Box sx={{ 
//   display: 'flex', 
//   flexDirection: 'column', 
//   minHeight: '100vh', 
//   backgroundColor: colors.background 
// }}>
// <AppBar
//   position="fixed"
//   sx={{
//     backgroundColor: colors.primary,
//     color: colors.textLight,
//     zIndex: 1200,
//   }}
// >
//   <Toolbar>
//     <IconButton
//       onClick={() => navigate(-1)}
//       sx={{ color: colors.textLight }}
//     >
//       <ArrowBackIosNewIcon />
//     </IconButton>

//     <Typography variant="h6" sx={{ ml: 2 }}>
//       JV/JD & Build to Suit Properties
//     </Typography>
//   </Toolbar>
// </AppBar>

//   {/* Main Content Area - Added pb to create space for bottom navbar */}
//   <Box sx={{ 
//     p: 1.5, 
//     flex: 1, 
//         pt: { xs: '80px', sm: '100px' },  
//     pb: 10, // Increased from pb: 8 to pb: 10
//     backgroundColor: colors.background,
//     overflowY: 'auto'
//   }}>
//     {data.length === 0 ? (
//       <Typography variant="h6" textAlign="center" sx={{ mt: 4, color: colors.textDark }}>
//         No JV/JD or Build to Suit properties found
//       </Typography>
//     ) : (
//       <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1.5 }}>
//         {data.map((item) => (
//           <Card 
//             key={item.property_id} 
//             onClick={() => handleCardClick(item.property_id)}
//             sx={{ 
//               borderRadius: 2, 
//               boxShadow: '0 2px 8px rgba(0,0,0,0.1)', 
//               border: `1px solid #e0e0e0`, 
//               overflow: 'hidden',
//               cursor: 'pointer',
//               mb: 1, // Added margin bottom for better spacing
//               '&:hover': {
//                 boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
//                 transform: 'translateY(-2px)',
//                 transition: 'all 0.2s ease-in-out'
//               }
//             }}
//           >
//             <CardContent sx={{ p: 0, '&:last-child': { pb: 0 } }}>
//               {/* Header section with Type */}
//               <Box sx={{ 
//                 p: 1, 
//                 display: 'flex', 
//                 alignItems: 'center', 
//                 justifyContent: 'space-between', 
//                 backgroundColor: colors.primary 
//               }}>
//                 <Box sx={{ 
//                   backgroundColor: "#b9a990", 
//                   color: colors.primary,
//                   px: 1.5,
//                   py: 0.5,
//                   borderRadius: 3,
//                   display: 'flex',
//                   alignItems: 'center',
//                   justifyContent: 'center'
//                 }}>
//                   <Typography variant="h6" fontWeight="bold" sx={{ fontSize: '0.9rem', lineHeight: 1 }}>
//                     {item.type?.toUpperCase() || "JV/JD"}
//                   </Typography>
//                 </Box>
                
//                 <Box sx={{ 
//                   backgroundColor: colors.cardBackground, 
//                   color: colors.primary,
//                   px: 1.5,
//                   py: 0.5,
//                   borderRadius: 3,
//                   display: 'flex',
//                   alignItems: 'center',
//                   justifyContent: 'center'
//                 }}>
//                   <Typography variant="subtitle1" fontWeight="bold" sx={{ lineHeight: 1, fontSize: '0.9rem' }}>
//                     Budget: {formatBudget(item.min_budget, item.max_budget)}
//                   </Typography>
//                 </Box>
//               </Box>

//               <Box sx={{ p: 1.5 }}>
//                 <Box sx={{ display: 'grid', gap: 0.75 }}>
//                   {/* Property Type */}
//                   {renderPropertyDetail("Property Type", item.property_type)}
                  
//                   {/* Location */}
//                   {renderPropertyDetail("Location", item.location)}
                  
//                   {/* Combined Min-Max Acres */}
//                   {(item.min_acres > 0 || item.max_acres > 0) && renderPropertyDetail(
//                     "Min-Max Acres", 
//                     item.min_acres > 0 && item.max_acres > 0 
//                       ? `${item.min_acres} - ${item.max_acres} acres`
//                       : item.min_acres > 0 
//                         ? `${item.min_acres} acres`
//                         : `${item.max_acres} acres`,
//                     colors.textDark
//                   )}
                  
//                   {/* Facing */}
//                   {item.facing && renderPropertyDetail("Facing", item.facing)}
                  
//                   {/* Ratio */}
//                   {item.ratio && renderPropertyDetail("Ratio", item.ratio)}
                  
//                   {/* Road Width */}
//                   {item.roadwidth && renderPropertyDetail("Road Width", `${item.roadwidth} ft`)}
                  
//                   {/* User and Date with Delete Button */}
//                   <Box sx={{ 
//                     display: 'flex', 
//                     alignItems: 'center', 
//                     justifyContent: 'space-between', 
//                     mt: 1.5 // Increased margin top
//                   }}>
//                     <Box sx={{ display: 'flex', alignItems: 'center' }}>
//                       <Avatar sx={{ 
//                         width: 16, 
//                         height: 16,  
//                         fontSize: '0.5rem',
//                         mr: 0.5
//                       }}>
//                         👤
//                       </Avatar>
//                       <Typography variant="body2" color={colors.textDark} sx={{ 
//                         fontSize: '0.75rem', 
//                         lineHeight: 1.2,
//                         fontWeight: 'bold'
//                       }}>
//                         CUST {userId}
//                       </Typography>
//                       <Typography variant="body2" color={colors.textMuted} sx={{ 
//                         fontSize: '0.75rem', 
//                         lineHeight: 1.2,
//                         ml: 1
//                       }}>
//                         {formatDate(item.created_at)}
//                       </Typography>
//                     </Box>
                    
//                     {/* Delete Button - Removed position: 'relative' */}
//                     <Box sx={{ 
//                       display: 'flex', 
//                       alignItems: 'center',
//                       justifyContent: 'center'
//                     }}>
//                       {/* Delete Button */}
// <Box sx={{ 
//   display: 'flex', 
//   alignItems: 'center',
//   justifyContent: 'center'
// }}>
//   <IconButton
//     onClick={(e) => handleDeleteProperty(e, item)}
//     disabled={deletingId === item.property_id}
//     sx={{
//       width: 28,
//       height: 28,
//       "&:hover": {
//         backgroundColor: "#ffebee",
//       }
//     }}
//   >
//     {deletingId === item.property_id ? (
//       <CircularProgress size={18} sx={{ color: "#ff4444" }} />
//     ) : (
//       <DeleteIcon sx={{ color: "#ff4444", fontSize: 18 }} />
//     )}
//   </IconButton>
// </Box>
//                     </Box>
//                   </Box>
//                 </Box>
//               </Box>
//             </CardContent>
//           </Card>
//         ))}
//       </Box>
//     )}
//   </Box>


//   {/* Delete Success */}
//       {showDeleteSuccess && (
//         <DeleteSuccessAlert
//           message={alertMessage}
//           onClose={() => {
//             setShowDeleteSuccess(false);
//             setAlertMessage("");
//           }}
//         />
//       )}
      
//       {/* Delete Failure */}
//       {showDeleteFailure && (
//         <DeleteFailureAlert
//           message={alertMessage}
//           onClose={() => {
//             setShowDeleteFailure(false);
//             setAlertMessage("");
//           }}
//         />
//       )}
// {showDeleteConfirm && propertyToDelete && (
//   <DeleteConfirmAlert
//     message={`Are you sure you want to delete this ${propertyToDelete.type || 'JV/JD'} property? This action cannot be undone.`}
//     onOk={() => {
//       setShowDeleteConfirm(false);
//       performDelete();
//     }}
//     onCancel={() => {
//       setShowDeleteConfirm(false);
//       setPropertyToDelete(null);
//     }}
//   />
// )}
//   {/* Bottom Navbar - Fixed position */}
//   <Box sx={{ 
//     position: "fixed", 
//     bottom: 0, 
//     left: 0, 
//     right: 0, 
//     zIndex: 1000 
//   }}>
//     <CustomBottomNavbar />
//   </Box>
// </Box>
//   );
// };

// export default BuiltSuitProperties;





//===========================================



// import React, { useEffect, useState, useContext } from "react";
// import axios from "axios";
// import {
//   AppBar,
//   Toolbar,
//   IconButton,
//   Typography,
//   Box,
//   Card,
//   CardContent,
//   Avatar,
//   CircularProgress,
// } from "@mui/material";
// import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
// import DeleteIcon from "@mui/icons-material/Delete";
// import LocationOnIcon from "@mui/icons-material/LocationOn";
// import AccessTimeIcon from "@mui/icons-material/AccessTime";
// import HandshakeOutlinedIcon from "@mui/icons-material/HandshakeOutlined";
// import { useNavigate } from "react-router-dom";
// import { AuthContext } from "../../AuthContext/AuthContext";
// import CustomBottomNavbar from "../../Users/Post Module/FormsBottomNavbar";
// import { BASE_URL } from "../../Api/ApiUrls";
// import DeleteFailureAlert from '../../../Components/Users/Alertpage/DeleteAlert/DeleteFailureAlert';
// import DeleteSuccessAlert from '../../../Components/Users/Alertpage/DeleteAlert/DeleteSuccessAlert';
// import DeleteConfirmAlert from '../../../Components/Users/Alertpage/DeleteAlert/DeleteConfirmAlert';

// const BuiltSuitProperties = () => {
//   const navigate = useNavigate();
//   const { userId } = useContext(AuthContext);

//   const [data, setData] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");
//   const [deletingId, setDeletingId] = useState(null);
//   const [showDeleteSuccess, setShowDeleteSuccess] = useState(false);
//   const [showDeleteFailure, setShowDeleteFailure] = useState(false);
//   const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
//   const [alertMessage, setAlertMessage] = useState("");
//   const [propertyToDelete, setPropertyToDelete] = useState(null);

//   const colors = {
//     primary: "#1a1a1a",
//     gold: "#D9A441",
//     goldSoft: "rgba(217,164,65,0.10)",
//     background: "rgb(239, 231, 221)",
//     cardBackground: "#FFFFFF",
//     line: "#E8E5E0",
//     textDark: "#1a1a1a",
//     textLight: "#FFFFFF",
//     textMuted: "#8a8a8a",
//     danger: "#E74C3C",
//   };

//   /* ==================== HELPERS ==================== */

//   const formatDate = (dateString) => {
//     if (!dateString) return "Not specified";
//     const date = new Date(dateString);
//     const now = new Date();
//     const diffMs = now - date;
//     const diffMins = Math.floor(diffMs / (1000 * 60));
//     const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
//     const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

//     if (diffMins < 60) return `${diffMins}m ago`;
//     if (diffHours < 24) return `${diffHours}h ago`;
//     if (diffDays < 7) return `${diffDays}d ago`;
//     return date.toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
//   };

//   const formatBudget = (min, max) => {
//     if (!min && !max) return "Not specified";

//     const formatNumber = (num) => {
//       const numValue = parseFloat(num) || 0;
//       if (numValue >= 10000000) return `₹${(numValue / 10000000).toFixed(1)} Cr`;
//       if (numValue >= 100000) return `₹${(numValue / 100000).toFixed(1)} L`;
//       if (numValue >= 1000) return `₹${(numValue / 1000).toFixed(1)} K`;
//       return `₹${numValue}`;
//     };

//     const minNum = parseFloat(min) || 0;
//     const maxNum = parseFloat(max) || 0;

//     if (minNum === maxNum) return formatNumber(minNum);
//     return `${formatNumber(minNum)} - ${formatNumber(maxNum)}`;
//   };

//   const formatAcres = (min, max) => {
//     const minNum = parseFloat(min) || 0;
//     const maxNum = parseFloat(max) || 0;
//     if (minNum > 0 && maxNum > 0) {
//       return minNum === maxNum ? `${minNum} acres` : `${minNum} - ${maxNum} acres`;
//     }
//     if (minNum > 0) return `${minNum} acres`;
//     if (maxNum > 0) return `${maxNum} acres`;
//     return "Not specified";
//   };

//   /* ==================== HANDLERS ==================== */

//   const handleDeleteProperty = (e, property) => {
//     e.stopPropagation();
//     setPropertyToDelete(property);
//     setShowDeleteConfirm(true);
//   };

//   const performDelete = async () => {
//     if (!propertyToDelete) return;

//     setDeletingId(propertyToDelete.property_id);

//     try {
//       await axios.delete(`${BASE_URL}/property/${propertyToDelete.property_id}/`);
//       setData((prevData) =>
//         prevData.filter((item) => item.property_id !== propertyToDelete.property_id)
//       );
//       setAlertMessage("JV/JD & Build to Suit property deleted successfully!");
//       setShowDeleteSuccess(true);
//     } catch (err) {
//       console.error("Error deleting property:", err);
//       setAlertMessage("Failed to delete property. Please try again.");
//       setShowDeleteFailure(true);
//     } finally {
//       setDeletingId(null);
//       setPropertyToDelete(null);
//     }
//   };

//   const handleCardClick = (propertyId) => {
//     navigate(`/jv-jv-property-detail/${propertyId}`);
//   };

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const [jvjdRes, buildToSuitRes] = await Promise.all([
//           axios.post(`${BASE_URL}/properties/filter/`, {
//             include: { user_id: Number(userId), type: "jv/jd" },
//             exclude: {},
//           }),
//           axios.post(`${BASE_URL}/properties/filter/`, {
//             include: { user_id: Number(userId), type: "build to suit" },
//             exclude: {},
//           }),
//         ]);

//         const jvjdData = jvjdRes.data?.data || [];
//         const buildToSuitData = buildToSuitRes.data?.data || [];

//         const combined = [...jvjdData, ...buildToSuitData].sort(
//           (a, b) => new Date(b.created_at) - new Date(a.created_at)
//         );

//         setData(combined);
//         setLoading(false);
//       } catch (err) {
//         setError("Failed to load JV/JD & Build to Suit properties");
//         setLoading(false);
//       }
//     };

//     if (userId) {
//       fetchData();
//     } else {
//       setLoading(false);
//       setError("User not authenticated");
//     }
//   }, [userId]);

//   /* ==================== SPEC CELL ==================== */

//   const SpecCell = ({ label, value, index, total }) => (
//     <Box
//       sx={{
//         px: 1.2,
//         py: 1,
//         position: "relative",
//         minWidth: 0,
//         // vertical divider except on the last column of each row
//         ...(index % 2 === 0 &&
//           index !== total - 1 && {
//             "&::after": {
//               content: '""',
//               position: "absolute",
//               right: 0,
//               top: "18%",
//               height: "64%",
//               width: "1px",
//               backgroundColor: colors.line,
//             },
//           }),
//         // horizontal divider except on the last row
//         ...(index < total - (total % 2 === 0 ? 2 : 1) && {
//           borderBottom: `1px solid ${colors.line}`,
//         }),
//       }}
//     >
//       <Typography
//         sx={{
//           fontSize: "0.62rem",
//           color: colors.textMuted,
//           textTransform: "uppercase",
//           letterSpacing: "0.5px",
//           fontWeight: 600,
//           mb: 0.2,
//         }}
//       >
//         {label}
//       </Typography>
//       <Typography
//         sx={{
//           fontSize: "0.78rem",
//           fontWeight: 700,
//           color: colors.textDark,
//           overflow: "hidden",
//           textOverflow: "ellipsis",
//           whiteSpace: "nowrap",
//         }}
//       >
//         {value || "Not specified"}
//       </Typography>
//     </Box>
//   );

//   /* ==================== CARD ==================== */

//   const renderCard = (item) => {
//     const specs = [
//       { label: "Property Type", value: item.property_type },
//       { label: "Land Area", value: formatAcres(item.min_acres, item.max_acres) },
//       { label: "Facing", value: item.facing?.replace(/"/g, "") },
//       { label: "Sharing Ratio", value: item.ratio },
//       { label: "Road Width", value: item.roadwidth ? `${item.roadwidth} ft` : null },
//       { label: "Property ID", value: item.property_id ? `#${item.property_id}` : null },
//     ];

//     return (
//       <Card
//         key={item.property_id}
//         onClick={() => handleCardClick(item.property_id)}
//         sx={{
//           borderRadius: "14px",
//           backgroundColor: colors.cardBackground,
//           border: `1px solid ${colors.line}`,
//           borderLeft: `4px solid ${colors.gold}`,
//           boxShadow: "0 2px 10px rgba(0,0,0,0.07)",
//           overflow: "hidden",
//           cursor: "pointer",
//           transition: "all 0.2s ease-in-out",
//           "&:hover": {
//             boxShadow: "0 6px 18px rgba(0,0,0,0.13)",
//             transform: "translateY(-2px)",
//           },
//         }}
//       >
//         <CardContent sx={{ p: 0, "&:last-child": { pb: 0 } }}>
//           {/* ---------- Header: type pill + posted time ---------- */}
//           <Box
//             sx={{
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "space-between",
//               px: 1.4,
//               pt: 1.3,
//               pb: 1,
//             }}
//           >
//             <Box
//               sx={{
//                 display: "flex",
//                 alignItems: "center",
//                 gap: 0.6,
//                 backgroundColor: colors.primary,
//                 color: colors.gold,
//                 px: 1.2,
//                 py: 0.5,
//                 borderRadius: "8px",
//               }}
//             >
//               <HandshakeOutlinedIcon sx={{ fontSize: 14 }} />
//               <Typography
//                 sx={{
//                   fontSize: "0.66rem",
//                   fontWeight: 700,
//                   letterSpacing: "0.6px",
//                   lineHeight: 1,
//                 }}
//               >
//                 {item.type?.toUpperCase() || "JV/JD"}
//               </Typography>
//             </Box>

//             <Box sx={{ display: "flex", alignItems: "center", gap: 0.4 }}>
//               <AccessTimeIcon sx={{ fontSize: 13, color: colors.textMuted }} />
//               <Typography sx={{ fontSize: "0.68rem", color: colors.textMuted }}>
//                 {formatDate(item.created_at)}
//               </Typography>
//             </Box>
//           </Box>

//           {/* ---------- Budget band ---------- */}
//           <Box
//             sx={{
//               mx: 1.4,
//               px: 1.4,
//               py: 1,
//               borderRadius: "10px",
//               backgroundColor: colors.goldSoft,
//               border: `1px dashed ${colors.gold}`,
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "space-between",
//               gap: 1,
//             }}
//           >
//             <Typography
//               sx={{
//                 fontSize: "0.62rem",
//                 fontWeight: 700,
//                 color: "#a9762a",
//                 textTransform: "uppercase",
//                 letterSpacing: "0.7px",
//               }}
//             >
//               Budget Range
//             </Typography>
//             <Typography
//               sx={{
//                 fontSize: "1.02rem",
//                 fontWeight: 800,
//                 color: colors.gold,
//                 whiteSpace: "nowrap",
//               }}
//             >
//               {formatBudget(item.min_budget, item.max_budget)}
//             </Typography>
//           </Box>

//           {/* ---------- Location ---------- */}
//           <Box
//             sx={{
//               display: "flex",
//               alignItems: "flex-start",
//               gap: 0.6,
//               px: 1.4,
//               pt: 1.2,
//               pb: 1,
//             }}
//           >
//             <LocationOnIcon sx={{ fontSize: 16, color: colors.textMuted, mt: "1px" }} />
//             <Typography
//               sx={{
//                 fontSize: "0.8rem",
//                 fontWeight: 600,
//                 color: colors.textDark,
//                 lineHeight: 1.3,
//               }}
//             >
//               {item.location || "Location not specified"}
//             </Typography>
//           </Box>

//           {/* ---------- Spec grid (2 columns, all fields) ---------- */}
//           <Box
//             sx={{
//               mx: 1.4,
//               mb: 1.2,
//               border: `1px solid ${colors.line}`,
//               borderRadius: "10px",
//               overflow: "hidden",
//               display: "grid",
//               gridTemplateColumns: "1fr 1fr",
//               backgroundColor: "#FCFBF9",
//             }}
//           >
//             {specs.map((spec, index) => (
//               <SpecCell
//                 key={spec.label}
//                 label={spec.label}
//                 value={spec.value}
//                 index={index}
//                 total={specs.length}
//               />
//             ))}
//           </Box>

//           {/* ---------- Footer: user + delete ---------- */}
//           <Box
//             sx={{
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "space-between",
//               px: 1.4,
//               py: 1,
//               borderTop: `1px solid ${colors.line}`,
//               backgroundColor: "#FAF8F5",
//             }}
//           >
//             <Box sx={{ display: "flex", alignItems: "center", gap: 0.7 }}>
//               <Avatar
//                 sx={{
//                   width: 24,
//                   height: 24,
//                   fontSize: "0.65rem",
//                   fontWeight: 700,
//                   bgcolor: colors.primary,
//                   color: colors.gold,
//                 }}
//               >
//                 {String(userId || "U").slice(-2)}
//               </Avatar>
//               <Box>
//                 <Typography
//                   sx={{ fontSize: "0.72rem", fontWeight: 700, color: colors.textDark, lineHeight: 1.1 }}
//                 >
//                   CUST {userId}
//                 </Typography>
//                 <Typography sx={{ fontSize: "0.62rem", color: colors.textMuted }}>
//                   Posted by you
//                 </Typography>
//               </Box>
//             </Box>

//             <IconButton
//               onClick={(e) => handleDeleteProperty(e, item)}
//               disabled={deletingId === item.property_id}
//               sx={{
//                 width: 30,
//                 height: 30,
//                 border: `1px solid rgba(231,76,60,0.35)`,
//                 borderRadius: "8px",
//                 "&:hover": { backgroundColor: "rgba(231,76,60,0.08)" },
//               }}
//             >
//               {deletingId === item.property_id ? (
//                 <CircularProgress size={16} sx={{ color: colors.danger }} />
//               ) : (
//                 <DeleteIcon sx={{ color: colors.danger, fontSize: 17 }} />
//               )}
//             </IconButton>
//           </Box>
//         </CardContent>
//       </Card>
//     );
//   };

//   /* ==================== RENDER ==================== */

//   if (loading) {
//     return (
//       <Box
//         sx={{
//           backgroundColor: colors.background,
//           minHeight: "100vh",
//           display: "flex",
//           flexDirection: "column",
//           justifyContent: "center",
//           alignItems: "center",
//           gap: 3,
//         }}
//       >
//         <CircularProgress size={40} thickness={5} sx={{ color: "#000000" }} />
//         <Typography variant="h7" sx={{ color: "#000000", fontWeight: 600 }}>
//           Loading JV/JD & Build to Suit properties...
//         </Typography>
//       </Box>
//     );
//   }

//   if (error)
//     return (
//       <Box
//         sx={{
//           display: "flex",
//           flexDirection: "column",
//           minHeight: "100vh",
//           backgroundColor: colors.background,
//           justifyContent: "center",
//           alignItems: "center",
//         }}
//       >
//         <Typography variant="h6" color="error">
//           {error}
//         </Typography>
//       </Box>
//     );

//   return (
//     <Box
//       sx={{
//         display: "flex",
//         flexDirection: "column",
//         minHeight: "100vh",
//         backgroundColor: colors.background,
//       }}
//     >
//       <AppBar
//         position="fixed"
//         sx={{ backgroundColor: colors.primary, color: colors.textLight, zIndex: 1200 }}
//       >
//         <Toolbar>
//           <IconButton onClick={() => navigate(-1)} sx={{ color: colors.textLight }}>
//             <ArrowBackIosNewIcon />
//           </IconButton>
//           <Typography variant="h6" sx={{ ml: 2, fontSize: "1.05rem" }}>
//             JV/JD & Build to Suit Properties
//           </Typography>
//         </Toolbar>
//       </AppBar>

//       <Box
//         sx={{
//           p: 1.5,
//           flex: 1,
//           pt: { xs: "60px", sm: "100px" },
//           pb: 10,
//           backgroundColor: colors.background,
//           overflowY: "auto",
//         }}
//       >
//         {data.length === 0 ? (
//           <Typography variant="h6" textAlign="center" sx={{ mt: 4, color: colors.textDark }}>
//             No JV/JD or Build to Suit properties found
//           </Typography>
//         ) : (
//           <>
//             <Typography
//               sx={{
//                 fontSize: "0.72rem",
//                 fontWeight: 700,
//                 color: "#6b6257",
//                 textTransform: "uppercase",
//                 letterSpacing: "0.8px",
//                 mb: 1,
//                 px: 0.5,
//               }}
//             >
//               {data.length} {data.length === 1 ? "Property" : "Properties"}
//             </Typography>

//             <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
//               {data.map((item) => renderCard(item))}
//             </Box>
//           </>
//         )}
//       </Box>

//       {/* Delete Success */}
//       {showDeleteSuccess && (
//         <DeleteSuccessAlert
//           message={alertMessage}
//           onClose={() => {
//             setShowDeleteSuccess(false);
//             setAlertMessage("");
//           }}
//         />
//       )}

//       {/* Delete Failure */}
//       {showDeleteFailure && (
//         <DeleteFailureAlert
//           message={alertMessage}
//           onClose={() => {
//             setShowDeleteFailure(false);
//             setAlertMessage("");
//           }}
//         />
//       )}

//       {showDeleteConfirm && propertyToDelete && (
//         <DeleteConfirmAlert
//           message={`Are you sure you want to delete this ${
//             propertyToDelete.type || "JV/JD"
//           } property? This action cannot be undone.`}
//           onOk={() => {
//             setShowDeleteConfirm(false);
//             performDelete();
//           }}
//           onCancel={() => {
//             setShowDeleteConfirm(false);
//             setPropertyToDelete(null);
//           }}
//         />
//       )}

//       <Box sx={{ position: "fixed", bottom: 0, left: 0, right: 0, zIndex: 1000 }}>
//         <CustomBottomNavbar />
//       </Box>
//     </Box>
//   );
// };

// export default BuiltSuitProperties;


// import React, { useEffect, useState, useContext } from "react";
// import axios from "axios";
// import {
//   AppBar,
//   Toolbar,
//   IconButton,
//   Typography,
//   Box,
//   Card,
//   CardContent,
//   Avatar,
//   CircularProgress,
//   CardMedia,
// } from "@mui/material";
// import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
// import DeleteIcon from "@mui/icons-material/Delete";
// import LocationOnIcon from "@mui/icons-material/LocationOn";
// import AccessTimeIcon from "@mui/icons-material/AccessTime";
// import HandshakeOutlinedIcon from "@mui/icons-material/HandshakeOutlined";
// import CheckCircleIcon from "@mui/icons-material/CheckCircle";
// import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";
// import CancelIcon from "@mui/icons-material/Cancel";
// import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
// import HomeWorkOutlinedIcon from "@mui/icons-material/HomeWork";
// import StraightenOutlinedIcon from "@mui/icons-material/Straighten";
// import ExploreOutlinedIcon from "@mui/icons-material/Explore";
// import AddRoadOutlinedIcon from "@mui/icons-material/AddRoad";
// import PeopleAltOutlinedIcon from "@mui/icons-material/PeopleAlt";
// import TagOutlinedIcon from "@mui/icons-material/Tag";
// import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
// import VisibilityOutlinedIcon from "@mui/icons-material/Visibility";
// import { useNavigate } from "react-router-dom";
// import { AuthContext } from "../../AuthContext/AuthContext";
// import CustomBottomNavbar from "../../Users/Post Module/FormsBottomNavbar";
// import { BASE_URL } from "../../Api/ApiUrls";
// import DeleteFailureAlert from "../../../Components/Users/Alertpage/DeleteAlert/DeleteFailureAlert";
// import DeleteSuccessAlert from "../../../Components/Users/Alertpage/DeleteAlert/DeleteSuccessAlert";
// import DeleteConfirmAlert from "../../../Components/Users/Alertpage/DeleteAlert/DeleteConfirmAlert";

// /* ==================== CHROME-TAKEN PLACEHOLDER IMAGES ==================== */
// /**
//  * These are the same style images you can capture from Chrome (right-click → "Copy image address")
//  * from a Google Images search like: "residential plot for JV" or "build to suit land".
//  * They are used as fallbacks because the API data in this component has no image field.
//  * Replace with your real image URLs (e.g. item.property_images?.[0]?.image) whenever available.
//  */
// const CHROME_PLACEHOLDER_IMAGES = [
//   // empty land / residential plot with road + open sky (matches top card in screenshot)
//   "https://images.unsplash.com/photo-1500382017468-9049fed747ef?w=800&q=80",
//   // commercial land / build-to-suit plot with building in the distance (matches bottom card)
//   "https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=800&q=80",
//   // additional fallbacks
//   "https://images.unsplash.com/photo-1449844908441-8829872d2607?w=800&q=80",
//   "https://images.unsplash.com/photo-1416331108676-a22ccb276e35?w=800&q=80",
// ];

// const getPlaceholderImage = (propertyId) => {
//   const idx = Number(propertyId || 0) % CHROME_PLACEHOLDER_IMAGES.length;
//   return CHROME_PLACEHOLDER_IMAGES[idx];
// };

// const BuiltSuitProperties = () => {
//   const navigate = useNavigate();
//   const { userId } = useContext(AuthContext);

//   const [data, setData] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState("");
//   const [deletingId, setDeletingId] = useState(null);
//   const [showDeleteSuccess, setShowDeleteSuccess] = useState(false);
//   const [showDeleteFailure, setShowDeleteFailure] = useState(false);
//   const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
//   const [alertMessage, setAlertMessage] = useState("");
//   const [propertyToDelete, setPropertyToDelete] = useState(null);
//   const [imageIndex, setImageIndex] = useState({});

//   const colors = {
//     primary: "#3B2314",
//     gold: "#B8860B",
//     goldSoft: "rgba(184,134,11,0.10)",
//     background: "rgb(239, 231, 221)",
//     cardBackground: "#FFFFFF",
//     line: "#E8E5E0",
//     textDark: "#1a1a1a",
//     textLight: "#FFFFFF",
//     textMuted: "#8a8a8a",
//     danger: "#E74C3C",
//     approved: "#2E7D32",
//     approvedBg: "#E8F5E9",
//     pending: "#F57C00",
//     pendingBg: "#FFF3E0",
//     rejected: "#C62828",
//     rejectedBg: "#FFEBEE",
//     specBg: "#FAF8F5",
//   };

//   /* ==================== HELPERS ==================== */

//   const formatDate = (dateString) => {
//     if (!dateString) return "Not specified";
//     const date = new Date(dateString);
//     const now = new Date();
//     const diffMs = now - date;
//     const diffMins = Math.floor(diffMs / (1000 * 60));
//     const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
//     const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

//     if (diffMins < 60) return `${diffMins}m ago`;
//     if (diffHours < 24) return `${diffHours}h ago`;
//     if (diffDays < 7) return `${diffDays}d ago`;
//     return date.toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
//   };

//   const formatDateLong = (dateString) => {
//     if (!dateString) return "—";
//     const date = new Date(dateString);
//     return date.toLocaleDateString("en-IN", {
//       day: "2-digit",
//       month: "short",
//       year: "numeric",
//     });
//   };

//   const formatBudget = (min, max) => {
//     if (!min && !max) return "Not specified";

//     const formatNumber = (num) => {
//       const numValue = parseFloat(num) || 0;
//       if (numValue >= 10000000) return `₹${(numValue / 10000000).toFixed(1)} Cr`;
//       if (numValue >= 100000) return `₹${(numValue / 100000).toFixed(1)} L`;
//       if (numValue >= 1000) return `₹${(numValue / 1000).toFixed(1)} K`;
//       return `₹${numValue}`;
//     };

//     const minNum = parseFloat(min) || 0;
//     const maxNum = parseFloat(max) || 0;

//     if (minNum === maxNum) return formatNumber(minNum);
//     return `${formatNumber(minNum)} - ${formatNumber(maxNum)}`;
//   };

//   const formatAcres = (min, max) => {
//     const minNum = parseFloat(min) || 0;
//     const maxNum = parseFloat(max) || 0;
//     if (minNum > 0 && maxNum > 0) {
//       return minNum === maxNum ? `${minNum} Acres` : `${minNum} - ${maxNum} Acres`;
//     }
//     if (minNum > 0) return `${minNum} Acres`;
//     if (maxNum > 0) return `${maxNum} Acres`;
//     return "Not specified";
//   };

//   const getStatusStyles = (status) => {
//     const s = (status || "").toLowerCase();
//     switch (s) {
//       case "approved":
//         return {
//           color: colors.approved,
//           bg: colors.approvedBg,
//           border: colors.approved,
//           icon: <CheckCircleIcon sx={{ fontSize: 13 }} />,
//           label: "Approved",
//         };
//       case "rejected":
//         return {
//           color: colors.rejected,
//           bg: colors.rejectedBg,
//           border: colors.rejected,
//           icon: <CancelIcon sx={{ fontSize: 13 }} />,
//           label: "Rejected",
//         };
//       default:
//         return {
//           color: colors.pending,
//           bg: colors.pendingBg,
//           border: colors.pending,
//           icon: <HourglassEmptyIcon sx={{ fontSize: 13 }} />,
//           label: "Pending",
//         };
//     }
//   };

//   /* ==================== HANDLERS ==================== */

//   const handleDeleteProperty = (e, property) => {
//     e.stopPropagation();
//     setPropertyToDelete(property);
//     setShowDeleteConfirm(true);
//   };

//   const performDelete = async () => {
//     if (!propertyToDelete) return;

//     setDeletingId(propertyToDelete.property_id);

//     try {
//       await axios.delete(`${BASE_URL}/property/${propertyToDelete.property_id}/`);
//       setData((prevData) =>
//         prevData.filter((item) => item.property_id !== propertyToDelete.property_id)
//       );
//       setAlertMessage("JV/JD & Build to Suit property deleted successfully!");
//       setShowDeleteSuccess(true);
//     } catch (err) {
//       console.error("Error deleting property:", err);
//       setAlertMessage("Failed to delete property. Please try again.");
//       setShowDeleteFailure(true);
//     } finally {
//       setDeletingId(null);
//       setPropertyToDelete(null);
//     }
//   };

//   const handleCardClick = (propertyId) => {
//     navigate(`/jv-jv-property-detail/${propertyId}`);
//   };

//   useEffect(() => {
//     const fetchData = async () => {
//       try {
//         const [jvjdRes, buildToSuitRes] = await Promise.all([
//           axios.post(`${BASE_URL}/properties/filter/`, {
//             include: { user_id: Number(userId), type: "jv/jd" },
//             exclude: {},
//           }),
//           axios.post(`${BASE_URL}/properties/filter/`, {
//             include: { user_id: Number(userId), type: "build to suit" },
//             exclude: {},
//           }),
//         ]);

//         const jvjdData = jvjdRes.data?.data || [];
//         const buildToSuitData = buildToSuitRes.data?.data || [];

//         const combined = [...jvjdData, ...buildToSuitData].sort(
//           (a, b) => new Date(b.created_at) - new Date(a.created_at)
//         );

//         setData(combined);
//         setLoading(false);
//       } catch (err) {
//         setError("Failed to load JV/JD & Build to Suit properties");
//         setLoading(false);
//       }
//     };

//     if (userId) {
//       fetchData();
//     } else {
//       setLoading(false);
//       setError("User not authenticated");
//     }
//   }, [userId]);

//   /* ==================== SPEC CELL ==================== */

//   const SpecCell = ({ icon, label, value, index, total }) => (
//     <Box
//       sx={{
//         px: 1.2,
//         py: 1,
//         position: "relative",
//         minWidth: 0,
//         display: "flex",
//         alignItems: "flex-start",
//         gap: 0.8,
//         // vertical divider except on the last column of each row
//         ...(index % 2 === 0 &&
//           index !== total - 1 && {
//             "&::after": {
//               content: '""',
//               position: "absolute",
//               right: 0,
//               top: "18%",
//               height: "64%",
//               width: "1px",
//               backgroundColor: colors.line,
//             },
//           }),
//         // horizontal divider except on the last row
//         ...(index < total - (total % 2 === 0 ? 2 : 1) && {
//           borderBottom: `1px solid ${colors.line}`,
//         }),
//       }}
//     >
//       <Box
//         sx={{
//           width: 26,
//           height: 26,
//           borderRadius: "6px",
//           backgroundColor: "#F3EFE8",
//           display: "flex",
//           alignItems: "center",
//           justifyContent: "center",
//           flexShrink: 0,
//           mt: 0.2,
//           color: "#8a7a5c",
//         }}
//       >
//         {icon}
//       </Box>
//       <Box sx={{ minWidth: 0 }}>
//         <Typography
//           sx={{
//             fontSize: "0.6rem",
//             color: colors.textMuted,
//             textTransform: "uppercase",
//             letterSpacing: "0.5px",
//             fontWeight: 600,
//             mb: 0.2,
//             lineHeight: 1.1,
//           }}
//         >
//           {label}
//         </Typography>
//         <Typography
//           sx={{
//             fontSize: "0.78rem",
//             fontWeight: 700,
//             color: colors.textDark,
//             overflow: "hidden",
//             textOverflow: "ellipsis",
//             whiteSpace: "nowrap",
//           }}
//         >
//           {value || "Not specified"}
//         </Typography>
//       </Box>
//     </Box>
//   );

//   /* ==================== CARD ==================== */

//   const renderCard = (item) => {
//     const specs = [
//       {
//         label: "Property Type",
//         value: item.property_type,
//         icon: <HomeWorkOutlinedIcon sx={{ fontSize: 15 }} />,
//       },
//       {
//         label: "Land Area",
//         value: formatAcres(item.min_acres, item.max_acres),
//         icon: <StraightenOutlinedIcon sx={{ fontSize: 15 }} />,
//       },
//       {
//         label: "Facing",
//         value: item.facing?.replace(/"/g, ""),
//         icon: <ExploreOutlinedIcon sx={{ fontSize: 15 }} />,
//       },
//       {
//         label: "Sharing Ratio",
//         value: item.ratio,
//         icon: <PeopleAltOutlinedIcon sx={{ fontSize: 15 }} />,
//       },
//       {
//         label: "Road Width",
//         value: item.roadwidth ? `${item.roadwidth} ft` : null,
//         icon: <AddRoadOutlinedIcon sx={{ fontSize: 15 }} />,
//       },
//       {
//         label: "Property ID",
//         value: item.property_id ? `#${item.property_id}` : null,
//         icon: <TagOutlinedIcon sx={{ fontSize: 15 }} />,
//       },
//     ];

//     const status = getStatusStyles(item.Admin_status || item.admin_status);
//     const image = getPlaceholderImage(item.property_id);

//     return (
//       <Card
//         key={item.property_id}
//         onClick={() => handleCardClick(item.property_id)}
//         sx={{
//           borderRadius: "14px",
//           backgroundColor: colors.cardBackground,
//           border: `1px solid ${colors.line}`,
//           boxShadow: "0 2px 10px rgba(0,0,0,0.07)",
//           overflow: "hidden",
//           cursor: "pointer",
//           transition: "all 0.2s ease-in-out",
//           "&:hover": {
//             boxShadow: "0 6px 18px rgba(0,0,0,0.13)",
//             transform: "translateY(-2px)",
//           },
//         }}
//       >
//         <CardContent sx={{ p: 0, "&:last-child": { pb: 0 } }}>
//           {/* ============ TOP ROW: IMAGE (LEFT) + DETAILS (RIGHT) ============ */}
//           <Box
//             sx={{
//               display: "flex",
//               gap: 1.2,
//               p: 1.2,
//               height: 210,
//               boxSizing: "border-box",
//             }}
//           >
//             {/* ---------- Image column ---------- */}
//             <Box
//               sx={{
//                 position: "relative",
//                 width: "42%",
//                 height: "100%",
//                 flexShrink: 0,
//                 borderRadius: "10px",
//                 overflow: "hidden",
//                 backgroundColor: "#F5F5F5",
//               }}
//             >
//               <CardMedia
//                 component="img"
//                 image={image}
//                 alt={item.property_type || "Property"}
//                 sx={{
//                   width: "100%",
//                   height: "100%",
//                   objectFit: "cover",
//                   display: "block",
//                 }}
//               />

//               {/* type pill overlay top-left */}
//               <Box
//                 sx={{
//                   position: "absolute",
//                   top: 8,
//                   left: 8,
//                   display: "flex",
//                   alignItems: "center",
//                   gap: 0.5,
//                   backgroundColor: colors.primary,
//                   color: "#F5C842",
//                   px: 0.9,
//                   py: 0.35,
//                   borderRadius: "6px",
//                   maxWidth: "90%",
//                 }}
//               >
//                 <HandshakeOutlinedIcon sx={{ fontSize: 12 }} />
//                 <Typography
//                   sx={{
//                     fontSize: "0.6rem",
//                     fontWeight: 700,
//                     letterSpacing: "0.3px",
//                     lineHeight: 1,
//                     whiteSpace: "nowrap",
//                     overflow: "hidden",
//                     textOverflow: "ellipsis",
//                   }}
//                 >
//                   {item.type?.toUpperCase() || "JV/JD"}
//                 </Typography>
//               </Box>

//               {/* heart overlay top-right */}
//               <IconButton
//                 size="small"
//                 onClick={(e) => e.stopPropagation()}
//                 sx={{
//                   position: "absolute",
//                   top: 6,
//                   right: 6,
//                   width: 26,
//                   height: 26,
//                   backgroundColor: "#fff",
//                   color: colors.danger,
//                   boxShadow: "0 1px 4px rgba(0,0,0,0.15)",
//                   "&:hover": { backgroundColor: "#fff" },
//                 }}
//               >
//                 <FavoriteBorderIcon sx={{ fontSize: 15 }} />
//               </IconButton>

//               {/* photo count chip bottom-left */}
//               <Box
//                 sx={{
//                   position: "absolute",
//                   bottom: 8,
//                   left: 8,
//                   backgroundColor: "rgba(0,0,0,0.65)",
//                   color: "#FFFFFF",
//                   fontSize: "0.6rem",
//                   fontWeight: 600,
//                   px: 0.8,
//                   py: 0.3,
//                   borderRadius: "5px",
//                   lineHeight: 1.1,
//                 }}
//               >
//                 1 / 1
//               </Box>
//             </Box>

//             {/* ---------- Details column ---------- */}
//             <Box
//               sx={{
//                 flex: 1,
//                 minWidth: 0,
//                 display: "flex",
//                 flexDirection: "column",
//                 justifyContent: "flex-start",
//                 gap: 0.6,
//               }}
//             >
//               {/* status + posted time */}
//               <Box
//                 sx={{
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "space-between",
//                   gap: 0.6,
//                   flexWrap: "wrap",
//                 }}
//               >
//                 <Box
//                   sx={{
//                     display: "flex",
//                     alignItems: "center",
//                     gap: 0.4,
//                     px: 0.8,
//                     py: 0.25,
//                     borderRadius: "6px",
//                     border: `1px solid ${status.border}`,
//                     backgroundColor: status.bg,
//                     color: status.color,
//                   }}
//                 >
//                   {status.icon}
//                   <Typography sx={{ fontSize: "0.62rem", fontWeight: 700, lineHeight: 1.1 }}>
//                     {status.label}
//                   </Typography>
//                 </Box>

//                 <Box sx={{ display: "flex", alignItems: "center", gap: 0.3 }}>
//                   <AccessTimeIcon sx={{ fontSize: 11, color: colors.textMuted }} />
//                   <Typography sx={{ fontSize: "0.62rem", color: colors.textMuted }}>
//                     {formatDate(item.created_at)}
//                   </Typography>
//                 </Box>
//               </Box>

//               {/* title */}
//               <Typography
//                 sx={{
//                   fontSize: "0.92rem",
//                   fontWeight: 800,
//                   color: colors.textDark,
//                   lineHeight: 1.25,
//                   display: "-webkit-box",
//                   WebkitLineClamp: 2,
//                   WebkitBoxOrient: "vertical",
//                   overflow: "hidden",
//                 }}
//               >
//                 {item.property_type || item.type || "Property"}
//               </Typography>

//               {/* location */}
//               <Box sx={{ display: "flex", alignItems: "flex-start", gap: 0.4 }}>
//                 <LocationOnIcon
//                   sx={{ fontSize: 13, color: colors.textMuted, mt: "1px", flexShrink: 0 }}
//                 />
//                 <Typography
//                   sx={{
//                     fontSize: "0.68rem",
//                     color: "#666",
//                     lineHeight: 1.3,
//                     display: "-webkit-box",
//                     WebkitLineClamp: 2,
//                     WebkitBoxOrient: "vertical",
//                     overflow: "hidden",
//                   }}
//                 >
//                   {item.location || "Location not specified"}
//                 </Typography>
//               </Box>

//               {/* date row */}
//               <Box sx={{ display: "flex", alignItems: "center", gap: 0.4 }}>
//                 <CalendarTodayOutlinedIcon sx={{ fontSize: 12, color: colors.textMuted }} />
//                 <Typography sx={{ fontSize: "0.66rem", color: "#666" }}>
//                   {formatDateLong(item.created_at)}
//                 </Typography>
//               </Box>

//               {/* days left row - derived from data if available */}
//               <Box sx={{ display: "flex", alignItems: "center", gap: 0.4 }}>
//                 <AccessTimeIcon sx={{ fontSize: 12, color: colors.textMuted }} />
//                 <Typography sx={{ fontSize: "0.66rem", color: "#666" }}>
//                   {item.expired_date
//                     ? `${Math.max(
//                         0,
//                         Math.ceil(
//                           (new Date(item.expired_date) - new Date()) / (1000 * 60 * 60 * 24)
//                         )
//                       )} days left`
//                     : "No Expiry"}
//                 </Typography>
//               </Box>

//               {/* budget band */}
//               <Box
//                 sx={{
//                   mt: 0.4,
//                   px: 1,
//                   py: 0.7,
//                   borderRadius: "8px",
//                   backgroundColor: colors.goldSoft,
//                   border: `1px dashed ${colors.gold}`,
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "space-between",
//                   gap: 0.5,
//                 }}
//               >
//                 <Typography
//                   sx={{
//                     fontSize: "0.58rem",
//                     fontWeight: 700,
//                     color: "#8a6a1f",
//                     textTransform: "uppercase",
//                     letterSpacing: "0.5px",
//                     lineHeight: 1.1,
//                   }}
//                 >
//                   Budget Range
//                 </Typography>
//                 <Typography
//                   sx={{
//                     fontSize: "0.85rem",
//                     fontWeight: 800,
//                     color: colors.gold,
//                     whiteSpace: "nowrap",
//                   }}
//                 >
//                   {formatBudget(item.min_budget, item.max_budget)}
//                 </Typography>
//               </Box>
//             </Box>
//           </Box>

//           {/* ============ SPEC GRID (2 columns) ============ */}
//           <Box
//             sx={{
//               mx: 1.2,
//               mb: 1,
//               border: `1px solid ${colors.line}`,
//               borderRadius: "10px",
//               overflow: "hidden",
//               display: "grid",
//               gridTemplateColumns: "1fr 1fr",
//               backgroundColor: colors.specBg,
//             }}
//           >
//             {specs.map((spec, index) => (
//               <SpecCell
//                 key={spec.label}
//                 icon={spec.icon}
//                 label={spec.label}
//                 value={spec.value}
//                 index={index}
//                 total={specs.length}
//               />
//             ))}
//           </Box>

//           {/* ============ FOOTER: USER + VIEW + WISHLIST + SUBSCRIPTION ============ */}
//           <Box
//             sx={{
//               display: "flex",
//               alignItems: "center",
//               justifyContent: "space-between",
//               gap: 0.8,
//               px: 1.2,
//               py: 1,
//               borderTop: `1px solid ${colors.line}`,
//               backgroundColor: "#FAF8F5",
//             }}
//           >
      
//             <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
//               <Box
//                 onClick={(e) => e.stopPropagation()}
//                 sx={{
//                   display: "flex",
//                   alignItems: "center",
//                   gap: 0.4,
//                   px: 1,
//                   py: 0.5,
//                   borderRadius: "7px",
//                   border: `1px solid ${colors.line}`,
//                   backgroundColor: "#fff",
//                   cursor: "pointer",
//                   "&:hover": { backgroundColor: "#F5F0E8" },
//                 }}
//               >
//                 <VisibilityOutlinedIcon sx={{ fontSize: 13, color: "#5a5a5a" }} />
//                 <Typography sx={{ fontSize: "0.66rem", fontWeight: 600, color: "#5a5a5a" }}>
//                   View
//                 </Typography>
//               </Box>

//               <Box
//                 onClick={(e) => e.stopPropagation()}
//                 sx={{
//                   display: "flex",
//                   alignItems: "center",
//                   gap: 0.4,
//                   px: 1,
//                   py: 0.5,
//                   borderRadius: "7px",
//                   border: `1px solid ${colors.line}`,
//                   backgroundColor: "#fff",
//                   cursor: "pointer",
//                   "&:hover": { backgroundColor: "#F5F0E8" },
//                 }}
//               >
//                 <FavoriteBorderIcon sx={{ fontSize: 13, color: "#5a5a5a" }} />
//                 <Typography sx={{ fontSize: "0.66rem", fontWeight: 600, color: "#5a5a5a" }}>
//                   Wishlist
//                 </Typography>
//               </Box>

           

//               <IconButton
//                 onClick={(e) => handleDeleteProperty(e, item)}
//                 disabled={deletingId === item.property_id}
//                 sx={{
//                   width: 26,
//                   height: 26,
//                   border: `1px solid rgba(231,76,60,0.35)`,
//                   borderRadius: "7px",
//                   ml: 0.3,
//                   "&:hover": { backgroundColor: "rgba(231,76,60,0.08)" },
//                 }}
//               >
//                 {deletingId === item.property_id ? (
//                   <CircularProgress size={14} sx={{ color: colors.danger }} />
//                 ) : (
//                   <DeleteIcon sx={{ color: colors.danger, fontSize: 15 }} />
//                 )}
//               </IconButton>
//             </Box>
//           </Box>
//         </CardContent>
//       </Card>
//     );
//   };

//   /* ==================== RENDER ==================== */

//   if (loading) {
//     return (
//       <Box
//         sx={{
//           backgroundColor: colors.background,
//           minHeight: "100vh",
//           display: "flex",
//           flexDirection: "column",
//           justifyContent: "center",
//           alignItems: "center",
//           gap: 3,
//         }}
//       >
//         <CircularProgress size={40} thickness={5} sx={{ color: "#000000" }} />
//         <Typography variant="h7" sx={{ color: "#000000", fontWeight: 600 }}>
//           Loading JV/JD & Build to Suit properties...
//         </Typography>
//       </Box>
//     );
//   }

//   if (error)
//     return (
//       <Box
//         sx={{
//           display: "flex",
//           flexDirection: "column",
//           minHeight: "100vh",
//           backgroundColor: colors.background,
//           justifyContent: "center",
//           alignItems: "center",
//         }}
//       >
//         <Typography variant="h6" color="error">
//           {error}
//         </Typography>
//       </Box>
//     );

//   return (
//     <Box
//       sx={{
//         display: "flex",
//         flexDirection: "column",
//         minHeight: "100vh",
//         backgroundColor: colors.background,
//       }}
//     >
//       <AppBar
//         position="fixed"
//         sx={{ backgroundColor: colors.primary, color: colors.textLight, zIndex: 1200 }}
//       >
//         <Toolbar>
//           <IconButton onClick={() => navigate(-1)} sx={{ color: colors.textLight }}>
//             <ArrowBackIosNewIcon />
//           </IconButton>
//           <Typography variant="h6" sx={{ ml: 2, fontSize: "1.05rem" }}>
//             JV/JD & Build to Suit Properties
//           </Typography>
//         </Toolbar>
//       </AppBar>

//       <Box
//         sx={{
//           p: 1.5,
//           flex: 1,
//           pt: { xs: "60px", sm: "100px" },
//           pb: 10,
//           backgroundColor: colors.background,
//           overflowY: "auto",
//         }}
//       >
//         {data.length === 0 ? (
//           <Typography variant="h6" textAlign="center" sx={{ mt: 4, color: colors.textDark }}>
//             No JV/JD or Build to Suit properties found
//           </Typography>
//         ) : (
//           <>
//             <Typography
//               sx={{
//                 fontSize: "0.72rem",
//                 fontWeight: 700,
//                 color: "#6b6257",
//                 textTransform: "uppercase",
//                 letterSpacing: "0.8px",
//                 mb: 1,
//                 px: 0.5,
//               }}
//             >
//               {data.length} {data.length === 1 ? "Property" : "Properties"}
//             </Typography>

//             <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
//               {data.map((item) => renderCard(item))}
//             </Box>
//           </>
//         )}
//       </Box>

//       {/* Delete Success */}
//       {showDeleteSuccess && (
//         <DeleteSuccessAlert
//           message={alertMessage}
//           onClose={() => {
//             setShowDeleteSuccess(false);
//             setAlertMessage("");
//           }}
//         />
//       )}

//       {/* Delete Failure */}
//       {showDeleteFailure && (
//         <DeleteFailureAlert
//           message={alertMessage}
//           onClose={() => {
//             setShowDeleteFailure(false);
//             setAlertMessage("");
//           }}
//         />
//       )}

//       {showDeleteConfirm && propertyToDelete && (
//         <DeleteConfirmAlert
//           message={`Are you sure you want to delete this ${
//             propertyToDelete.type || "JV/JD"
//           } property? This action cannot be undone.`}
//           onOk={() => {
//             setShowDeleteConfirm(false);
//             performDelete();
//           }}
//           onCancel={() => {
//             setShowDeleteConfirm(false);
//             setPropertyToDelete(null);
//           }}
//         />
//       )}

//       <Box sx={{ position: "fixed", bottom: 0, left: 0, right: 0, zIndex: 1000 }}>
//         <CustomBottomNavbar />
//       </Box>
//     </Box>
//   );
// };

// export default BuiltSuitProperties;


import React, { useEffect, useState, useContext } from "react";
import axios from "axios";
import {
  AppBar,
  Toolbar,
  IconButton,
  Typography,
  Box,
  Card,
  CardContent,
  Avatar,
  CircularProgress,
  CardMedia,
  Button,
} from "@mui/material";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";
import DeleteIcon from "@mui/icons-material/Delete";
import LocationOnIcon from "@mui/icons-material/LocationOn";
import AccessTimeIcon from "@mui/icons-material/AccessTime";
import HandshakeOutlinedIcon from "@mui/icons-material/HandshakeOutlined";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";
import CancelIcon from "@mui/icons-material/Cancel";
import CalendarTodayOutlinedIcon from "@mui/icons-material/CalendarTodayOutlined";
import HomeWorkOutlinedIcon from "@mui/icons-material/HomeWork";
import StraightenOutlinedIcon from "@mui/icons-material/Straighten";
import ExploreOutlinedIcon from "@mui/icons-material/Explore";
import AddRoadOutlinedIcon from "@mui/icons-material/AddRoad";
import PeopleAltOutlinedIcon from "@mui/icons-material/PeopleAlt";
import TagOutlinedIcon from "@mui/icons-material/Tag";
import FavoriteBorderIcon from "@mui/icons-material/FavoriteBorder";
import VisibilityOutlinedIcon from "@mui/icons-material/Visibility";
import RocketIcon from "@mui/icons-material/RocketLaunch";
import { useNavigate } from "react-router-dom";
import { AuthContext } from "../../AuthContext/AuthContext";
import CustomBottomNavbar from "../../Users/Post Module/FormsBottomNavbar";
import { BASE_URL } from "../../Api/ApiUrls";
import DeleteFailureAlert from "../../../Components/Users/Alertpage/DeleteAlert/DeleteFailureAlert";
import DeleteSuccessAlert from "../../../Components/Users/Alertpage/DeleteAlert/DeleteSuccessAlert";
import DeleteConfirmAlert from "../../../Components/Users/Alertpage/DeleteAlert/DeleteConfirmAlert";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
/* ==================== CHROME-TAKEN PLACEHOLDER IMAGES ==================== */
const CHROME_PLACEHOLDER_IMAGES = [
  "https://images.unsplash.com/photo-1500382017468-9049fed747ef?w=800&q=80",
  "https://images.unsplash.com/photo-1560518883-ce09059eeffa?w=800&q=80",
  "https://images.unsplash.com/photo-1449844908441-8829872d2607?w=800&q=80",
  "https://images.unsplash.com/photo-1416331108676-a22ccb276e35?w=800&q=80",
];

const getPlaceholderImage = (propertyId) => {
  const idx = Number(propertyId || 0) % CHROME_PLACEHOLDER_IMAGES.length;
  return CHROME_PLACEHOLDER_IMAGES[idx];
};

const BuiltSuitProperties = () => {
  const navigate = useNavigate();
  const { userId } = useContext(AuthContext);

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [deletingId, setDeletingId] = useState(null);
  const [showDeleteSuccess, setShowDeleteSuccess] = useState(false);
  const [showDeleteFailure, setShowDeleteFailure] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [propertyToDelete, setPropertyToDelete] = useState(null);
  const [imageIndex, setImageIndex] = useState({});
  const [subscriptions, setSubscriptions] = useState([]);

  const colors = {
    primary: "#3B2314",
    gold: "#B8860B",
    goldSoft: "rgba(184,134,11,0.10)",
    background: "rgb(239, 231, 221)",
    cardBackground: "#FFFFFF",
    line: "#E8E5E0",
    textDark: "#1a1a1a",
    textLight: "#FFFFFF",
    textMuted: "#8a8a8a",
    danger: "#E74C3C",
    approved: "#2E7D32",
    approvedBg: "#E8F5E9",
    pending: "#F57C00",
    pendingBg: "#FFF3E0",
    rejected: "#C62828",
    rejectedBg: "#FFEBEE",
    specBg: "#FAF8F5",
  };

  /* ==================== HELPERS ==================== */

  const formatDate = (dateString) => {
    if (!dateString) return "Not specified";
    const date = new Date(dateString);
    const now = new Date();
    const diffMs = now - date;
    const diffMins = Math.floor(diffMs / (1000 * 60));
    const diffHours = Math.floor(diffMs / (1000 * 60 * 60));
    const diffDays = Math.floor(diffMs / (1000 * 60 * 60 * 24));

    if (diffMins < 60) return `${diffMins}m ago`;
    if (diffHours < 24) return `${diffHours}h ago`;
    if (diffDays < 7) return `${diffDays}d ago`;
    return date.toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
  };

  const formatDateLong = (dateString) => {
    if (!dateString) return "—";
    const date = new Date(dateString);
    return date.toLocaleDateString("en-IN", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    });
  };

  const formatBudget = (min, max) => {
    if (!min && !max) return "Not specified";

    const formatNumber = (num) => {
      const numValue = parseFloat(num) || 0;
      if (numValue >= 10000000) return `₹${(numValue / 10000000).toFixed(1)} Cr`;
      if (numValue >= 100000) return `₹${(numValue / 100000).toFixed(1)} L`;
      if (numValue >= 1000) return `₹${(numValue / 1000).toFixed(1)} K`;
      return `₹${numValue}`;
    };

    const minNum = parseFloat(min) || 0;
    const maxNum = parseFloat(max) || 0;

    if (minNum === maxNum) return formatNumber(minNum);
    return `${formatNumber(minNum)} - ${formatNumber(maxNum)}`;
  };

  const formatAcres = (min, max) => {
    const minNum = parseFloat(min) || 0;
    const maxNum = parseFloat(max) || 0;
    if (minNum > 0 && maxNum > 0) {
      return minNum === maxNum ? `${minNum} Acres` : `${minNum} - ${maxNum} Acres`;
    }
    if (minNum > 0) return `${minNum} Acres`;
    if (maxNum > 0) return `${maxNum} Acres`;
    return "Not specified";
  };

  /* ✅ Days Left — same logic as BuyPropertyCard */
  const calculateDaysLeft = (expiredDate) => {
    if (!expiredDate) return null;
    const now = new Date();
    const expiry = new Date(expiredDate);
    const diffTime = expiry - now;
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays > 0 ? diffDays : 0;
  };

  /* ✅ Map posted_by to subscription user_type */
  const mapPostedByToUserType = (postedBy) => {
    if (!postedBy) return null;
    const value = postedBy.toLowerCase();
    if (value === "owner" || value === "builder") return "Individual Owner/Builder";
    if (value === "agent") return "Agent";
    return null;
  };

  /* ✅ Compute daysLeft for a property using subscription data */
  const getDaysLeftForProperty = (item) => {
    const postedBy = item.posted_by?.replace(/"/g, "") || item.type || "";
    const requiredUserType =
      postedBy.toLowerCase() === "agent" ? "Agent" : "Individual Owner/Builder";
    const matchedSub = subscriptions.find(
      (sub) => sub.status === true && sub.user_type === requiredUserType
    );
    if (matchedSub?.expired_date) {
      return calculateDaysLeft(matchedSub.expired_date);
    }
    // Fallback: use item.expired_date if API returns it directly
    if (item.expired_date) {
      return calculateDaysLeft(item.expired_date);
    }
    return null;
  };

  const getStatusStyles = (status) => {
    const s = (status || "").toLowerCase();
    switch (s) {
      case "approved":
        return {
          color: colors.approved,
          bg: colors.approvedBg,
          border: colors.approved,
          icon: <CheckCircleIcon sx={{ fontSize: 13 }} />,
          label: "Approved",
        };
      case "rejected":
        return {
          color: colors.rejected,
          bg: colors.rejectedBg,
          border: colors.rejected,
          icon: <CancelIcon sx={{ fontSize: 13 }} />,
          label: "Rejected",
        };
      default:
        return {
          color: colors.pending,
          bg: colors.pendingBg,
          border: colors.pending,
          icon: <HourglassEmptyIcon sx={{ fontSize: 13 }} />,
          label: "Pending",
        };
    }
  };

  /* ==================== HANDLERS ==================== */

  const handleDeleteProperty = (e, property) => {
    e.stopPropagation();
    setPropertyToDelete(property);
    setShowDeleteConfirm(true);
  };

  const performDelete = async () => {
    if (!propertyToDelete) return;

    setDeletingId(propertyToDelete.property_id);

    try {
      await axios.delete(`${BASE_URL}/property/${propertyToDelete.property_id}/`);
      setData((prevData) =>
        prevData.filter((item) => item.property_id !== propertyToDelete.property_id)
      );
      setAlertMessage("JV/JD & Build to Suit property deleted successfully!");
      setShowDeleteSuccess(true);
    } catch (err) {
      console.error("Error deleting property:", err);
      setAlertMessage("Failed to delete property. Please try again.");
      setShowDeleteFailure(true);
    } finally {
      setDeletingId(null);
      setPropertyToDelete(null);
    }
  };

  const handleCardClick = (propertyId) => {
    navigate(`/jv-jv-property-detail/${propertyId}`);
  };

  /* ✅ Extend Your Post — same as BuyPropertyCard */
  const handleExtensionClick = (e) => {
    e.stopPropagation();
    navigate("/user-subscription");
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [jvjdRes, buildToSuitRes] = await Promise.all([
          axios.post(`${BASE_URL}/properties/filter/`, {
            include: { user_id: Number(userId), type: "jv/jd" },
            exclude: {},
          }),
          axios.post(`${BASE_URL}/properties/filter/`, {
            include: { user_id: Number(userId), type: "build to suit" },
            exclude: {},
          }),
        ]);

        const jvjdData = jvjdRes.data?.data || [];
        const buildToSuitData = buildToSuitRes.data?.data || [];

        const combined = [...jvjdData, ...buildToSuitData].sort(
          (a, b) => new Date(b.created_at) - new Date(a.created_at)
        );

        setData(combined);

        /* ✅ Fetch subscriptions for Days Left calculation */
        try {
          const plansResponse = await axios.get(`${BASE_URL}/Get-all-plan/${userId}/`);
          setSubscriptions(plansResponse.data || []);
        } catch (subErr) {
          console.log("No subscription data found");
        }

        setLoading(false);
      } catch (err) {
        setError("Failed to load JV/JD & Build to Suit properties");
        setLoading(false);
      }
    };

    if (userId) {
      fetchData();
    } else {
      setLoading(false);
      setError("User not authenticated");
    }
  }, [userId]);

  /* ==================== SPEC CELL ==================== */

  const SpecCell = ({ icon, label, value, index, total }) => (
    <Box
      sx={{
        px: 1.2,
        py: 1,
        position: "relative",
        minWidth: 0,
        display: "flex",
        alignItems: "flex-start",
        gap: 0.8,
        ...(index % 2 === 0 &&
          index !== total - 1 && {
            "&::after": {
              content: '""',
              position: "absolute",
              right: 0,
              top: "18%",
              height: "64%",
              width: "1px",
              backgroundColor: colors.line,
            },
          }),
        ...(index < total - (total % 2 === 0 ? 2 : 1) && {
          borderBottom: `1px solid ${colors.line}`,
        }),
      }}
    >
      <Box
        sx={{
          width: 26,
          height: 26,
          borderRadius: "6px",
          backgroundColor: "#F3EFE8",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          flexShrink: 0,
          mt: 0.2,
          color: "#8a7a5c",
        }}
      >
        {icon}
      </Box>
      <Box sx={{ minWidth: 0 }}>
        <Typography
          sx={{
            fontSize: "0.6rem",
            color: colors.textMuted,
            textTransform: "uppercase",
            letterSpacing: "0.5px",
            fontWeight: 600,
            mb: 0.2,
            lineHeight: 1.1,
          }}
        >
          {label}
        </Typography>
        <Typography
          sx={{
            fontSize: "0.78rem",
            fontWeight: 700,
            color: colors.textDark,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {value || "Not specified"}
        </Typography>
      </Box>
    </Box>
  );

  /* ==================== CARD ==================== */

  const renderCard = (item) => {
    const specs = [
      {
        label: "Property Type",
        value: item.property_type,
        icon: <HomeWorkOutlinedIcon sx={{ fontSize: 15 }} />,
      },
      {
        label: "Land Area",
        value: formatAcres(item.min_acres, item.max_acres),
        icon: <StraightenOutlinedIcon sx={{ fontSize: 15 }} />,
      },
      {
        label: "Facing",
        value: item.facing?.replace(/"/g, ""),
        icon: <ExploreOutlinedIcon sx={{ fontSize: 15 }} />,
      },
      {
        label: "Sharing Ratio",
        value: item.ratio,
        icon: <PeopleAltOutlinedIcon sx={{ fontSize: 15 }} />,
      },
      {
        label: "Road Width",
        value: item.roadwidth ? `${item.roadwidth} ft` : null,
        icon: <AddRoadOutlinedIcon sx={{ fontSize: 15 }} />,
      },
      {
        label: "Property ID",
        value: item.property_id ? `#${item.property_id}` : null,
        icon: <TagOutlinedIcon sx={{ fontSize: 15 }} />,
      },
    ];

    const status = getStatusStyles(item.Admin_status || item.admin_status);
    const image = getPlaceholderImage(item.property_id);
    const daysLeft = getDaysLeftForProperty(item);

    return (
      <Card
        key={item.property_id}
        onClick={() => handleCardClick(item.property_id)}
        sx={{
          borderRadius: "14px",
          backgroundColor: colors.cardBackground,
          border: `1px solid ${colors.line}`,
          boxShadow: "0 2px 10px rgba(0,0,0,0.07)",
          overflow: "hidden",
          cursor: "pointer",
          transition: "all 0.2s ease-in-out",
          "&:hover": {
            boxShadow: "0 6px 18px rgba(0,0,0,0.13)",
            transform: "translateY(-2px)",
          },
        }}
      >
        <CardContent sx={{ p: 0, "&:last-child": { pb: 0 } }}>
          {/* ============ TOP ROW: IMAGE (LEFT) + DETAILS (RIGHT) ============ */}
          <Box
            sx={{
              display: "flex",
              gap: 1.2,
              p: 1.2,
              height: 210,
              boxSizing: "border-box",
            }}
          >
            {/* ---------- Image column ---------- */}
            <Box
              sx={{
                position: "relative",
                width: "42%",
                height: "100%",
                flexShrink: 0,
                borderRadius: "10px",
                overflow: "hidden",
                backgroundColor: "#F5F5F5",
              }}
            >
              <CardMedia
                component="img"
                image={image}
                alt={item.property_type || "Property"}
                sx={{
                  width: "100%",
                  height: "100%",
                  objectFit: "cover",
                  display: "block",
                }}
              />

              {/* type pill overlay top-left */}
              <Box
                sx={{
                  position: "absolute",
                  top: 8,
                  left: 8,
                  display: "flex",
                  alignItems: "center",
                  gap: 0.5,
                  backgroundColor: colors.primary,
                  color: "#F5C842",
                  px: 0.9,
                  py: 0.35,
                  borderRadius: "6px",
                  maxWidth: "90%",
                }}
              >
                <HandshakeOutlinedIcon sx={{ fontSize: 12 }} />
                <Typography
                  sx={{
                    fontSize: "0.6rem",
                    fontWeight: 700,
                    letterSpacing: "0.3px",
                    lineHeight: 1,
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                  }}
                >
                  {item.type?.toUpperCase() || "JV/JD"}
                </Typography>
              </Box>

              {/* heart overlay top-right */}
              <IconButton
                size="small"
                onClick={(e) => e.stopPropagation()}
                sx={{
                  position: "absolute",
                  top: 6,
                  right: 6,
                  width: 26,
                  height: 26,
                  backgroundColor: "#fff",
                  color: colors.danger,
                  boxShadow: "0 1px 4px rgba(0,0,0,0.15)",
                  "&:hover": { backgroundColor: "#fff" },
                }}
              >
                <FavoriteBorderIcon sx={{ fontSize: 15 }} />
              </IconButton>

              {/* photo count chip bottom-left */}
              <Box
                sx={{
                  position: "absolute",
                  bottom: 8,
                  left: 8,
                  backgroundColor: "rgba(0,0,0,0.65)",
                  color: "#FFFFFF",
                  fontSize: "0.6rem",
                  fontWeight: 600,
                  px: 0.8,
                  py: 0.3,
                  borderRadius: "5px",
                  lineHeight: 1.1,
                }}
              >
                1 / 1
              </Box>
            </Box>

            {/* ---------- Details column ---------- */}
            <Box
              sx={{
                flex: 1,
                minWidth: 0,
                display: "flex",
                flexDirection: "column",
                justifyContent: "flex-start",
                gap: 0.6,
              }}
            >
              {/* status + posted time */}
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: 0.6,
                  flexWrap: "wrap",
                }}
              >
                <Box
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    gap: 0.4,
                    px: 0.8,
                    py: 0.25,
                    borderRadius: "6px",
                    border: `1px solid ${status.border}`,
                    backgroundColor: status.bg,
                    color: status.color,
                  }}
                >
                  {status.icon}
                  <Typography sx={{ fontSize: "0.62rem", fontWeight: 700, lineHeight: 1.1 }}>
                    {status.label}
                  </Typography>
                </Box>

                <Box sx={{ display: "flex", alignItems: "center", gap: 0.3 }}>
                  <AccessTimeIcon sx={{ fontSize: 11, color: colors.textMuted }} />
                  <Typography sx={{ fontSize: "0.62rem", color: colors.textMuted }}>
                    {formatDate(item.created_at)}
                  </Typography>
                </Box>
              </Box>

              {/* title */}
              <Typography
                sx={{
                  fontSize: "0.92rem",
                  fontWeight: 800,
                  color: colors.textDark,
                  lineHeight: 1.25,
                  display: "-webkit-box",
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: "vertical",
                  overflow: "hidden",
                }}
              >
                {item.property_type || item.type || "Property"}
              </Typography>

              {/* location */}
              <Box sx={{ display: "flex", alignItems: "flex-start", gap: 0.4 }}>
                <LocationOnIcon
                  sx={{ fontSize: 13, color: colors.textMuted, mt: "1px", flexShrink: 0 }}
                />
                <Typography
                  sx={{
                    fontSize: "0.68rem",
                    color: "#666",
                    lineHeight: 1.3,
                    display: "-webkit-box",
                    WebkitLineClamp: 2,
                    WebkitBoxOrient: "vertical",
                    overflow: "hidden",
                  }}
                >
                  {item.location || "Location not specified"}
                </Typography>
              </Box>

              {/* date row */}
              <Box sx={{ display: "flex", alignItems: "center", gap: 0.4 }}>
                <CalendarTodayOutlinedIcon sx={{ fontSize: 12, color: colors.textMuted }} />
                <Typography sx={{ fontSize: "0.66rem", color: "#666" }}>
                  {formatDateLong(item.created_at)}
                </Typography>
              </Box>

              {/* ✅ days left row with color coding */}
              <Box sx={{ display: "flex", alignItems: "center", gap: 0.4 }}>
                <AccessTimeIcon sx={{ fontSize: 12, color: colors.textMuted }} />
                <Typography
                  sx={{
                    fontSize: "0.8rem",
                    fontWeight: 700,
                    color:
                      daysLeft === null
                        ? "#1976d2"
                        : daysLeft === 0
                        ? "#e53935"
                        : daysLeft <= 7
                        ? "#ff9800"
                        : "#2e7d32",
                  }}
                >
                  {daysLeft === null
                    ? "No Expiry"
                    : daysLeft === 0
                    ? "Expired"
                    : `${daysLeft} days left`}
                </Typography>
              </Box>

              {/* budget band */}
              <Box
                sx={{
                  mt: 0.4,
                  px: 1,
                  py: 0.7,
                  borderRadius: "8px",
                  backgroundColor: colors.goldSoft,
                  border: `1px dashed ${colors.gold}`,
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                  gap: 0.5,
                }}
              >
                <Typography
                  sx={{
                    fontSize: "0.58rem",
                    fontWeight: 700,
                    color: "#8a6a1f",
                    textTransform: "uppercase",
                    letterSpacing: "0.5px",
                    lineHeight: 1.1,
                  }}
                >
                  Budget Range
                </Typography>
                <Typography
                  sx={{
                    fontSize: "0.85rem",
                    fontWeight: 800,
                    color: colors.gold,
                    whiteSpace: "nowrap",
                  }}
                >
                  {formatBudget(item.min_budget, item.max_budget)}
                </Typography>
              </Box>
            </Box>
          </Box>

          {/* ============ SPEC GRID (2 columns) ============ */}
          <Box
            sx={{
              mx: 1.2,
              mb: 1,
              border: `1px solid ${colors.line}`,
              borderRadius: "10px",
              overflow: "hidden",
              display: "grid",
              gridTemplateColumns: "1fr 1fr",
              backgroundColor: colors.specBg,
            }}
          >
            {specs.map((spec, index) => (
              <SpecCell
                key={spec.label}
                icon={spec.icon}
                label={spec.label}
                value={spec.value}
                index={index}
                total={specs.length}
              />
            ))}
          </Box>

         {/* ============ FOOTER: EXTEND + VIEW + WISHLIST + EDIT + DELETE ============ */}
<Box
  sx={{
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    gap: 0.8,
    px: 1.2,
    py: 1,
    borderTop: `1px solid ${colors.line}`,
    backgroundColor: "#FAF8F5",
    flexWrap: "wrap",
  }}
>
  <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, flexWrap: "wrap" }}>
    {/* Extend Your Post */}
    <Button
      variant="outlined"
      disabled={daysLeft !== null && daysLeft > 7}
      onClick={handleExtensionClick}
      startIcon={<AccessTimeIcon sx={{ fontSize: 15, color: "#c3790b" }} />}
      sx={{
        textTransform: "none",
        borderRadius: "7px",
        fontSize: "0.66rem",
        fontWeight: 600,
        backgroundColor: "#fff",
        borderColor: "#d0d0d0",
        color: "#c3790b",
        px: 1,
        py: 0.4,
        whiteSpace: "nowrap",
        minWidth: 0,
        "&:hover": { backgroundColor: "#f5f5f5", borderColor: "#d0d0d0" },
        "&.Mui-disabled": {
          backgroundColor: "#fff",
          borderColor: "#d0d0d0",
          color: "#c3790b",
          opacity: 0.6,
        },
      }}
    >
      Extend Your Post
    </Button>

    {/* View */}
    <Box
      onClick={(e) => e.stopPropagation()}
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 0.4,
        px: 1,
        py: 0.5,
        borderRadius: "7px",
        border: `1px solid ${colors.line}`,
        backgroundColor: "#fff",
        cursor: "pointer",
        "&:hover": { backgroundColor: "#F5F0E8" },
      }}
    >
      <VisibilityOutlinedIcon sx={{ fontSize: 13, color: "#5a5a5a" }} />
      <Typography sx={{ fontSize: "0.66rem", fontWeight: 600, color: "#5a5a5a" }}>
        View
      </Typography>
    </Box>

    {/* Wishlist */}
    <Box
      onClick={(e) => e.stopPropagation()}
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 0.4,
        px: 1,
        py: 0.5,
        borderRadius: "7px",
        border: `1px solid ${colors.line}`,
        backgroundColor: "#fff",
        cursor: "pointer",
        "&:hover": { backgroundColor: "#F5F0E8" },
      }}
    >
      <FavoriteBorderIcon sx={{ fontSize: 13, color: "#5a5a5a" }} />
      <Typography sx={{ fontSize: "0.66rem", fontWeight: 600, color: "#5a5a5a" }}>
        Wishlist
      </Typography>
    </Box>
  </Box>

  {/* ── EDIT + DELETE at the very end ── */}
  <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, ml: "auto" }}>
    {/* Edit */}
    <Button
      variant="outlined"
      size="small"
      onClick={(e) => {
        e.stopPropagation();
        navigate(`/user-edit-jvjd/${item.property_id}`);
      }}
      startIcon={<EditOutlinedIcon sx={{ fontSize: 14 }} />}
      sx={{
        textTransform: "none",
        borderRadius: "7px",
        fontSize: "0.66rem",
        fontWeight: 600,
        backgroundColor: "#fff",
        borderColor: "rgba(184,134,11,0.5)",
        color: colors.gold,
        px: 1,
        py: 0.4,
        whiteSpace: "nowrap",
        minWidth: 0,
        "&:hover": {
          backgroundColor: "rgba(184,134,11,0.08)",
          borderColor: colors.gold,
        },
      }}
    >
      Edit
    </Button>

    {/* Delete */}
    <Button
      variant="outlined"
      size="small"
      disabled={deletingId === item.property_id}
      onClick={(e) => handleDeleteProperty(e, item)}
      startIcon={
        deletingId === item.property_id ? (
          <CircularProgress size={12} sx={{ color: colors.danger }} />
        ) : (
          <DeleteIcon sx={{ fontSize: 14 }} />
        )
      }
      sx={{
        textTransform: "none",
        borderRadius: "7px",
        fontSize: "0.66rem",
        fontWeight: 600,
        backgroundColor: "#fff",
        borderColor: "rgba(231,76,60,0.5)",
        color: colors.danger,
        px: 1,
        py: 0.4,
        whiteSpace: "nowrap",
        minWidth: 0,
        "&:hover": {
          backgroundColor: "rgba(231,76,60,0.08)",
          borderColor: colors.danger,
        },
        "&.Mui-disabled": {
          backgroundColor: "#fff",
          borderColor: "rgba(231,76,60,0.5)",
          color: colors.danger,
          opacity: 0.6,
        },
      }}
    >
      Delete
    </Button>
  </Box>
</Box>
        </CardContent>
      </Card>
    );
  };

  /* ==================== RENDER ==================== */

  if (loading) {
    return (
      <Box
        sx={{
          backgroundColor: colors.background,
          minHeight: "100vh",
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          gap: 3,
        }}
      >
        <CircularProgress size={40} thickness={5} sx={{ color: "#000000" }} />
        <Typography variant="h7" sx={{ color: "#000000", fontWeight: 600 }}>
          Loading JV/JD & Build to Suit properties...
        </Typography>
      </Box>
    );
  }

  if (error)
    return (
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          minHeight: "100vh",
          backgroundColor: colors.background,
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <Typography variant="h6" color="error">
          {error}
        </Typography>
      </Box>
    );

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        minHeight: "100vh",
        backgroundColor: colors.background,
      }}
    >
      <AppBar
        position="fixed"
        sx={{ backgroundColor: colors.primary, color: colors.textLight, zIndex: 1200 }}
      >
        <Toolbar>
          <IconButton onClick={() => navigate(-1)} sx={{ color: colors.textLight }}>
            <ArrowBackIosNewIcon />
          </IconButton>
          <Typography variant="h6" sx={{ ml: 2, fontSize: "1.05rem" }}>
            JV/JD & Build to Suit Properties
          </Typography>
        </Toolbar>
      </AppBar>

      <Box
        sx={{
          p: 1.5,
          flex: 1,
          pt: { xs: "60px", sm: "100px" },
          pb: 10,
          backgroundColor: colors.background,
          overflowY: "auto",
        }}
      >
        {data.length === 0 ? (
          <Typography variant="h6" textAlign="center" sx={{ mt: 4, color: colors.textDark }}>
            No JV/JD or Build to Suit properties found
          </Typography>
        ) : (
          <>
            <Typography
              sx={{
                fontSize: "0.72rem",
                fontWeight: 700,
                color: "#6b6257",
                textTransform: "uppercase",
                letterSpacing: "0.8px",
                mb: 1,
                px: 0.5,
              }}
            >
              {data.length} {data.length === 1 ? "Property" : "Properties"}
            </Typography>

            <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
              {data.map((item) => renderCard(item))}
            </Box>
          </>
        )}
      </Box>

      {/* Delete Success */}
      {showDeleteSuccess && (
        <DeleteSuccessAlert
          message={alertMessage}
          onClose={() => {
            setShowDeleteSuccess(false);
            setAlertMessage("");
          }}
        />
      )}

      {/* Delete Failure */}
      {showDeleteFailure && (
        <DeleteFailureAlert
          message={alertMessage}
          onClose={() => {
            setShowDeleteFailure(false);
            setAlertMessage("");
          }}
        />
      )}

      {showDeleteConfirm && propertyToDelete && (
        <DeleteConfirmAlert
          message={`Are you sure you want to delete this ${
            propertyToDelete.type || "JV/JD"
          } property? This action cannot be undone.`}
          onOk={() => {
            setShowDeleteConfirm(false);
            performDelete();
          }}
          onCancel={() => {
            setShowDeleteConfirm(false);
            setPropertyToDelete(null);
          }}
        />
      )}

      <Box sx={{ position: "fixed", bottom: 0, left: 0, right: 0, zIndex: 1000 }}>
        <CustomBottomNavbar />
      </Box>
    </Box>
  );
};

export default BuiltSuitProperties;